module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "ibox float-e-margins"
  }, [_c('div', {
    staticClass: "ibox-title"
  }, [_c('h2', [_vm._v(_vm._s(_vm.userId ? 'Edit' : 'Create') + " User")])]), _c('div', {
    staticClass: "ibox-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('form', {
    attrs: {
      "role": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Name")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "name", $event.target.value)
      }
    }
  })]), (_vm.userId == null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Username")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "username", $event.target.value)
      }
    }
  })]) : _vm._e(), (_vm.userId == null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "password", $event.target.value)
      }
    }
  })]) : _vm._e(), (_vm.userId == null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Re-Password")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.repassword),
      expression: "user.repassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "placeholder": "Re-Password"
    },
    domProps: {
      "value": (_vm.user.repassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "repassword", $event.target.value)
      }
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Role")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.role_id),
      expression: "user.role_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.user, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.roles), function(role) {
    return _c('option', {
      domProps: {
        "value": role.id
      }
    }, [_vm._v(_vm._s(role.name))])
  }))]), _c('div', [_c('button', {
    staticClass: "btn btn-sm btn-primary m-t-n-xs",
    attrs: {
      "type": "submit"
    }
  }, [(_vm.userId) ? _c('strong', [_vm._v("Save")]) : _c('strong', [_vm._v("Create")])]), _vm._v("   "), _c('button', {
    staticClass: "btn btn-sm btn-white m-t-n-xs",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_c('strong', [_vm._v("Cancel")])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9240a8c4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index/users/edit.vue
// module id = 428
// module chunks = 3